import { Stack, Typography, Grid } from '@mui/material'
import ProductTable from './table'

const ProductManagement = () => {
  return (
    <Stack spacing={3}>
      <Stack p={2} borderRadius={4} spacing={4} sx={{ background: '#fff' }}>
        <Typography variant="h3" color="primary">
          Product Management
        </Typography>
      </Stack>
      <Stack>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ProductTable />
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  )
}

export default ProductManagement
